import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  metaData: {},
};

const handleUpdateMetaData = (state, { data }) => {
  const metaData = { ...data };
  return { ...state, metaData };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_META_DATA:
      return handleUpdateMetaData(state, action);
    default:
      return state;
  }
};
